module.exports = __webpack_public_path__ + "img/jt.287ae23c.png";